import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { SvgImage } from '.';
import PropTypes from 'prop-types';

const regMatchExternal = /^http*/i;

export class NavigationLink extends Component {
  isExternal( url ) {
    return ( url || '' ).match( regMatchExternal );
  }

  renderLabel( label ) {
    return !label ? null : <span>{label}</span>;
  }

  renderImage( image ) {
    return !image ? null : <SvgImage source={ image } className="m-svg-size" />;
  }

  fetchClassNames( classNames, isActiveFn, activeClassName ) {
    let { router } = this.context;
    return isActiveFn && isActiveFn.apply && isActiveFn( router.route.match.path ) ? classNames + ' ' + activeClassName : classNames;
  }

  render() {
    let { target, label, image, isActive, activeClassName, className, tooltip } = this.props;
    if ( !target || this.isExternal( target ) ) {
      return <a title={ tooltip } className={ this.fetchClassNames( className, isActive, activeClassName ) } href={ target }>
        { this.renderLabel( label ) }
        { this.renderImage( image ) }
      </a>;
    }
    return <Link title={ tooltip } className={ this.fetchClassNames( className, isActive, activeClassName ) } to={ target }>
      { this.renderLabel( label ) }
      { this.renderImage( image ) }
    </Link>;
  }
}

NavigationLink.propTypes = {
  activeClassName: PropTypes.string,
  className: PropTypes.string,
  image: PropTypes.string,
  isActive: PropTypes.func,
  label: PropTypes.string,
  target: PropTypes.string,
  tooltip: PropTypes.string
};

NavigationLink.contextTypes = {
  router: PropTypes.object
};